import { render, staticRenderFns } from "./TemplateCreate.vue?vue&type=template&id=7ddd5312"
import script from "./TemplateCreate.vue?vue&type=script&lang=js"
export * from "./TemplateCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports